import { useAuth } from "@clerk/tanstack-react-start";
import React from "react";
import { Route as RootRoute } from "~/routes/__root";

export function SignedOut({ children }: { children: React.ReactNode }) {
	const { isSignedIn, isLoaded } = useAuth();
	const { navbarViewer } = RootRoute.useRouteContext();

	if (!isLoaded) return navbarViewer ? null : children;
	if (isSignedIn) return null;
	return children;
}
